import { apiClient } from '@/lib/api/api-client';
import axiosInstance from '@/lib/api/axios-instance';
import { ENDPOINTS } from '@/lib/api/endpoints';
import { UserItem, CreateUserData, UpdateUserData } from '../types/user.types';

/**
 * Servicio para gestión de usuarios
 */
class UserService {
  async getUsers(): Promise<UserItem[]> {
    return apiClient.get<UserItem[]>(ENDPOINTS.USERS);
  }

  async getUserById(id: string): Promise<UserItem> {
    return apiClient.get<UserItem>(ENDPOINTS.USER_BY_ID(id));
  }

  async createUser(data: CreateUserData): Promise<UserItem> {
    return apiClient.post<UserItem>(ENDPOINTS.USERS, data);
  }

  async updateUser(id: string, data: UpdateUserData): Promise<UserItem> {
    return apiClient.put<UserItem>(ENDPOINTS.USER_BY_ID(id), data);
  }

  async deleteUser(id: string): Promise<void> {
    return apiClient.delete<void>(ENDPOINTS.USER_BY_ID(id));
  }

  /**
   * Restablece la contraseña de otra persona, siendo admin.
   *
   * Va por `axiosInstance` y no por `apiClient` a propósito: este endpoint no
   * devuelve `data`, devuelve `message` y `warning` en la raíz, y `apiClient`
   * retorna solo `response.data.data` — con él el aviso se perdería.
   *
   * El aviso importa: cambiar la contraseña **no** cierra las sesiones abiertas.
   */
  async resetPassword(id: string, newPassword: string): Promise<{ warning?: string }> {
    const { data } = await axiosInstance.post<{ message: string; warning?: string }>(
      ENDPOINTS.USER_RESET_PASSWORD(id),
      { newPassword }
    );
    return { warning: data.warning };
  }
}

export const userService = new UserService();
export default userService;
